<template lang="pug">
div
  template(v-if="!pageLoading")
    .sgbox.lv2.aaa
      .gbox
        #preloader(v-if="gameLaunching")
          #loader
        div(v-if="!pageLoading")
          template(v-if="listToDisplay.length > 0")
            template(v-for="game in filteredList()")
              .ggl(v-if="game.GameType == 1")
                a(href="javascript:void(0)" @click='launchGame(game.GameId)')
                  //- img(:src="game.ImageUrl" @error="$helpers.handleImageError")
                  v-lazy-image(:src="game.ImageUrl" src-placeholder="/images/fallb/epicwin.png" @error="$helpers.handleImageError($event,'epicwin')")
                  span {{game.GameName}}
                .progress
                  .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import VLazyImage from "v-lazy-image/v2";
import config from '@/config'
import _ from "lodash";
export default {
  components: {
    VLazyImage,
  },
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision,
      gameOrder:[
        {id: "40054"},
        {id: "45008"},
        {id: "45007"},
        {id: "48001"},
        {id: "45006"},
        {id: "45005"},
        {id: "45004"},
        {id: "40053"},
        {id: "45003"},
        {id: "40052"},
        {id: "45001"},
        {id: "45000"},
        {id: "40046"},
        {id: "40039"},
        {id: "40051"},
        {id: "40002"},
        {id: "40050"},
        {id: "40042"},
        {id: "40041"},
        {id: "40043"},
        {id: "40022"}, 
        {id: "40028"},
        {id: "40034"},
        {id: '40014'},
        {id: "40017"},
        {id: '40003'},
      ],
      gameOrderTue:[
        {id: "40042"},
        {id: "40043"},
        {id: "40050"},
        {id: "40051"},
        {id: "49999"},
        {id: "40041"},
        {id: "40022"},
        {id: "40039"},
        {id: "40028"},
        {id: "40034"},
        {id: '40014'},
        {id: "40017"},
        {id: '40003'},
      ],
      gameOrderWed:[
        {id: "40007"},
        {id: "40016"},
        {id: "40011"},
        {id: "40051"},
        {id: "40050"},
        {id: "49999"},
        {id: "40042"},
        {id: "40041"},
        {id: "40043"},
        {id: "40022"},
        {id: "40039"},
        {id: "40028"},
        {id: "40034"},
        {id: '40014'},
        {id: "40017"},
        {id: '40003'},
      ],
      tueSpecial:[ "40042","40043","40050",
      ],
      wedSpecial:["40007", "40016","40011",
      ],
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    },
    showTue(){
      var now = this.$moment().day()
      var hour = this.$moment().hour()
      if ((now === 2 && hour >= 20) || (now === 3 && hour < 2)) {
        return true
      }else{
        return false
      }
    },
    showWed(){
      var now = this.$moment().day()
      var hour = this.$moment().hour()
      if ((now === 3 && hour >= 20) || (now === 4 && hour < 2)) {
        return true
      }else{
        return false
      }
    }
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "EPIC2"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getEpic2list() + this.matchedLocale
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              var _0x3e85dd=_0x33e3;function _0x33e3(_0x1e7aca,_0x1d1b4d){var _0x1d43e3=_0xa853();return _0x33e3=function(_0x1facb8,_0x2f6ced){_0x1facb8=_0x1facb8-(0x2259+0xf*0x13a+-0x32e3);var _0x14871d=_0x1d43e3[_0x1facb8];return _0x14871d;},_0x33e3(_0x1e7aca,_0x1d1b4d);}(function(_0x4ba299,_0x137ace){var _0x6d7332=_0x33e3,_0x51dd12=_0x4ba299();while(!![]){try{var _0x30baa5=parseInt(_0x6d7332(0x1dc))/(0x411*0x8+-0x537+0x170*-0x13)*(-parseInt(_0x6d7332(0x1e7))/(-0x244+0x118e+-0xf48))+parseInt(_0x6d7332(0x1e4))/(-0x2*0xee6+0x2188+-0x3b9*0x1)*(parseInt(_0x6d7332(0x1e0))/(-0x402+0x1*-0x195a+0x1d60))+-parseInt(_0x6d7332(0x1dd))/(0x1a29+0x26b1+-0x40d5)*(parseInt(_0x6d7332(0x1e5))/(0xcb6+0x1ef5+-0x2ba5*0x1))+-parseInt(_0x6d7332(0x1df))/(0x2c3+-0x522+0x266*0x1)*(-parseInt(_0x6d7332(0x1e9))/(-0x8e6*0x3+-0x6a1+0x215b))+-parseInt(_0x6d7332(0x1ea))/(0x6*0x28c+0x26ac+0x1*-0x35eb)*(-parseInt(_0x6d7332(0x1de))/(-0x1b6d+0x1*-0x2381+0x1a*0x26c))+parseInt(_0x6d7332(0x1e8))/(0x7*-0x433+-0xd45+0x2ab5)*(parseInt(_0x6d7332(0x1e3))/(-0x2696+-0x6df*-0x5+-0x447*-0x1))+-parseInt(_0x6d7332(0x1e1))/(0x2550+-0x1*-0xec3+0x2*-0x1a03);if(_0x30baa5===_0x137ace)break;else _0x51dd12['push'](_0x51dd12['shift']());}catch(_0x3a2d6a){_0x51dd12['push'](_0x51dd12['shift']());}}}(_0xa853,-0x1*-0xbd76e+0xd8ef1+0x5ae8b*-0x3),this[_0x3e85dd(0x1e2)]=successResponse[_0x3e85dd(0x1eb)][_0x3e85dd(0x1e6)]);function _0xa853(){var _0x17264b=['6GlIukt','6408CuHJcf','Game','5448IbRcaa','11SBEVjm','64txUjXF','90Hvsctq','data','229fpttLX','1195KCbTuo','651730gNoPqe','210938yaShTa','1558444EvGDWV','10050924cCjRhz','gameList','6332280CEXXaE'];_0xa853=function(){return _0x17264b;};return _0xa853();}
              eval(function(p,a,c,k,e,d){e=function(c){return c.toString(36)};if(!''.replace(/^/,String)){while(c--){d[c.toString(a)]=k[c]||c.toString(a)}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('f.e.d(c(5){5["b"]=a((9.8()*(0.7-0.4)+0.4).3(0.6)*1).3(2)})',16,16,'vm|||toFixed|min|item|precision|max|random|Math|parseFloat|rtp|function|forEach|gameList|this'.split('|'),0,{}))
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.GameCode === obj2.game_id)
              )
              // if(this.showTue === true){
              //   var reOrderList = this.gameOrderTue.map(x => x.id);
              //   for (let i = 0; i < this.listToDisplay.length; i++) {
              //     if (this.tueSpecial.includes(this.listToDisplay[i].GameCode)) {
              //       this.listToDisplay[i].rtp = 99;
              //     }
              //   }
              // }else if(this.showWed === true){
              //   var reOrderList = this.gameOrderWed.map(x => x.id);
              //   for (let i = 0; i < this.listToDisplay.length; i++) {
              //     if (this.wedSpecial.includes(this.listToDisplay[i].GameCode)) {
              //       this.listToDisplay[i].rtp = 99;
              //     }
              //   }
              // }else{
              //   var reOrderList = this.gameOrder.map(x => x.id);
              // }
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.GameCode);
                const index2 = reOrderList.indexOf(item2.GameCode);
                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    launchGame(game){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = this.matchedLocale
        this.$store
          .dispatch("user/launchEpic2", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.GameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
  }
}
</script>